import { StepOne } from '../components/StepOne';

export const NewStepOne = () => {
  return <StepOne />;
};
